import { useKeycloak } from '@react-keycloak/web'
import Roles from "../../roles/Roles";

const useAuthProvider = () => {
  const {keycloak} = useKeycloak()

  return ({
    login: () => {
      console.log('login')
      return keycloak.login()
    },
    checkError: () => Promise.resolve(),
    checkAuth: () => {
      return keycloak.authenticated &&
      keycloak.token ? Promise.resolve() : Promise.reject("Failed to obtain access token.");
    },
    logout: () => keycloak.logout(),
    getPermissions:() => {
      return Promise.resolve(true);

      if (keycloak.token) {
        if (Roles.hasAccess('canSetSettings')) {
          //window.location.replace('/');
          return Promise.resolve(true);
        } else {
          return Promise.resolve(false);
          //return Promise.reject();
        }

      }
    },
  });
};

export default useAuthProvider;
